import React, { useEffect, useMemo, useState } from "react";
import { Box, Text, Accordion, AccordionItem, AccordionButton, AccordionPanel, AccordionIcon, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import ExpenseTable from "../vendorDetail/expenseTable";
import { fetchAsyncAccountStatement } from "redux/paymentSlice";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetAutomatedBank } from "redux/embrillProfileSlice";
import CustomDropdown from "../vendorDetail/vendorLedger/customDateRenge";
import { getFirstDayOfMonth } from "jsFunctions/dateTime";
import { getLastDayOfMonth } from "jsFunctions/dateTime";
import { formatDate } from "jsFunctions/dateTime";
import { financialYearOptions } from "jsFunctions/dateTime";
import { fetchAsyncGetAccountUser } from "redux/embrillProfileSlice";
import useExpenseModule from "hooks/organizaton/useExpenseModule";
import {  FaPlusCircle } from "react-icons/fa";
import { fetchAsyncAccountStatementValidate } from "redux/paymentSlice";


const statementColumns = [
  {
    Header: "No",
    accessor: "no",
  },
  {
    Header: "PoNo",
    accessor: "poNo",
  },
  {
    Header: "Vendor Name",
    accessor: "vendor",
  },
  {
    Header: "Payment Type",
    accessor: "paymentType",
  },
  {
    Header: "Transaction Id",
    accessor: "transactionId",
  },
  {
    Header: "Txn Date",
    accessor: "txnDate",
  },
  {
    Header: "Remarks",
    accessor: "remarks",
  },
  {
    Header: "Type",
    accessor: "type",
  },
  {
    Header: "Amount",
    accessor: "amount",
  },
  {
    Header: "Balance",
    accessor: "balance",
  },
  {
    Header: "Action",
    accessor: "action",
  },
 
]



const formatApiDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0'); 
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};


const StatementValidate = () => {
  const dispatch = useDispatch();
  const { addToast } = useToasts();
  const [dateRenge,setDateRenge] = useState({
    startDate:'',
    endDate:''
  })
  const [loading, setLoading] = useState(false);
  const [accountDetail,setAccountDetail] = useState({})
  const [statementRecords,setStatementRecords] = useState([])
  const currUser = useSelector((state) => state.auth.currUser);
  const [accountUser,setAccountUser] = useState({})
  const [selectedPeriod, setSelectedPeriod] = useState('lastOneWeek');
  const [dateRangeText, setDateRangeText] = useState('');
  const { moduleType } = useExpenseModule();
  
  useEffect(() => {
    const getAccountUser = async () => {
      if (currUser && currUser._id) {
        const res = await dispatch(fetchAsyncGetAccountUser(currUser._id));
        if (res?.payload?.isA) {
          setAccountUser(res?.payload);
        } else {
          setAccountUser({});
        }
      } else {
        setAccountUser({});
      }
    };

    getAccountUser();
  }, [currUser?._id, dispatch]);

  const getBankDetails = ()=>{
    setLoading(true); 
    dispatch(fetchAsyncGetAutomatedBank())
      .then((res) => {
        
        setLoading(false); 
        if(res?.payload && res?.payload?._id){
          setAccountDetail(res?.payload)
        }
      })
      .catch((error) => {
        setLoading(false); 
      }); 
    }

  useEffect(() => {
    getBankDetails()
  }, []);

  useEffect(() => {
    const today = new Date();
    let startDate = null;
    let endDate = today;
    switch (selectedPeriod) {
      case 'lastOneWeek':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 6);
        // startDate = new Date("01-01-2024")
        // endDate = new Date("02-10-2024")
        break;
      case 'last15Days':
        startDate = new Date(today);
        startDate.setDate(today.getDate() - 14);
        break;
      case 'currentMonth':
        startDate = getFirstDayOfMonth(today);
        break;
      case 'lastMonth':
        const prevMonthDate = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        startDate = getFirstDayOfMonth(prevMonthDate);
        endDate = getLastDayOfMonth(prevMonthDate);
        break;
      case 'last3Months':
        const threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 2, 1);
        startDate = getFirstDayOfMonth(threeMonthsAgo);
        break;
      case 'last6Months':
        const sixMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 5, 1);
        startDate = getFirstDayOfMonth(sixMonthsAgo);
        break;
      case 'currentFinancialYear':
        startDate = new Date(today.getFullYear(), 3, 1); 
        endDate = new Date(today.getFullYear(), 2, 31); 
        break;
      case 'lastFinancialYear':
        startDate = new Date(today.getFullYear() - 1, 3, 1); 
        endDate = new Date(today.getFullYear() - 1, 2, 31); 
        break;
      default:
        startDate = today;
        break;
    }
    if (startDate && endDate && accountDetail?._id && selectedPeriod !== 'custom') {
      setDateRangeText(`${formatDate(startDate)} to ${formatDate(endDate)}`);
      getAccountStatements(startDate, endDate);
    } 
    else if (dateRenge.startDate && dateRenge.endDate && accountDetail?._id && selectedPeriod === 'custom') {
      setDateRangeText(`${formatDate(dateRenge.startDate)} to ${formatDate(dateRenge.endDate)}`);
      startDate = dateRenge.startDate;
      endDate = dateRenge.endDate
      getAccountStatements(startDate, endDate);
    } 
    else {
      setDateRangeText('');
    }
  }, [selectedPeriod,accountDetail,dateRenge,accountUser]);

  const getAccountStatements = async (startDate, endDate) => {
    const startStr = formatApiDate(startDate);
    const endStr = formatApiDate(endDate);
    try {
      fetchStatementDetails(startStr,endStr)
    } catch (error) {
      console.error('Failed to fetch account statements:', error);
    }
  };

  const fetchStatementDetails = async (startDate,endDate) => {
      setLoading(true)
      if(accountUser?.useId){
        const data = {
          aggrId: accountDetail?.aggId, 
          corpId: accountDetail?.corId, 
          userId: accountUser?.useId, 
          debitAcc: accountDetail?.bnk?.acNo,
          urn: accountDetail?.urn, 
          startDate: startDate, 
          endDate: endDate, 
        }
        const userID = accountDetail?.useIds?.find((opt)=>opt?.useId === accountUser?.useId);
        if(userID && userID?.sts === 'Registered'){
          dispatch(fetchAsyncAccountStatementValidate(data))
          .then((res) => {
            if (res?.payload && res?.payload?.data) {
              const records = res?.payload?.data?.Record || []
              setStatementRecords(records)
            } else {
              addToast(`${res?.error?.message}`, { appearance: "error" });
            }
          })
          .catch((error) => {
            addToast(`error`, { appearance: "error" });
          }).finally(()=>{
            setLoading(false)
          });
        }
        else{
          setLoading(false)
          addToast('userId is not registered!', { appearance: "error" });

        }
      }
  };

  const getTypeStyles = (type) => {
    const styles = {
        Automated: { color: '#28a745', fontWeight: 'bold' }, 
        Manual: { color: '#007bff', fontWeight: 'bold' },    
        GST: { color: '#4CB0B0', fontWeight: 'bold' } 
    };
    return styles[type] || {};
};
  const statementData = useMemo(()=>{
    if(statementRecords && statementRecords?.length > 0){
      const tableData = statementRecords.sort((a, b) => {
        const dateA = new Date(a.TXNDATE);
        const dateB = new Date(b.TXNDATE);
        return dateB  > dateA;
      }).map((data, index) => {
        const matchData = data?.matchedData || []
        return {
          _id: data._id,
          no: index + 1,
          poNo : (<span className="blue">{matchData && matchData.length ? 
            matchData.map((item) => 
                item.poNo ? item.poNo : ""
            ).filter(po => po !== "").join(", ") 
            : "NA"}</span>),
          vendor:(matchData && matchData.length ? 
            matchData.map((item) => 
                item.vendorName ? item?.vendorName : ""
            ).filter(vendor => vendor !== "").join(", ") 
            : "NA"),
            paymentType:(matchData && matchData.length ? 
              <span style={getTypeStyles(matchData[0].typ) || {}}>{matchData[0].typ} </span>
              : "NA"),
          checkNo: <span>{data?.CHEQUENO}</span>,
          txnDate: <span>{data?.TXNDATE}</span>,
          remarks: <span>{data?.REMARKS}</span>,
          amount: (
            <span className={`${data?.TYPE === 'CR' ? 'green' :'red'}`}>
              ₹ {data?.AMOUNT}
            </span>
          ),
          balance: (
            <span className="f-600">
              ₹ {data?.BALANCE}
            </span>
          ),
          type: <span className="f-600">{data?.TYPE}</span>,
          transactionId: (<span>{data?.TRANSACTIONID}</span>),
          action: (
            data?.TYPE === 'DR' && !matchData?.length ?
            <div className="item-export-menu add-new-btn">
              <Menu>
                <MenuButton
                  title="Add New"
                  className="new-btn add-new-menu-btn"
                >
                  <Box display="flex">
                    <FaPlusCircle fontSize={16} color="green"/>
                  </Box>
                </MenuButton>
                  <MenuList className="menu-list">
                    {moduleType && moduleType?.length > 0 && moduleType?.map((module)=>{
                      return (
                      <MenuItem
                        className={`menu-item`}
                        onClick={() => {
                          window.location.href = `/${module?.pth}/${module._id}`;
                        }}
                      >
                        {module?.name}
                      </MenuItem>
                      )
                    })} 
                   
                    
                  </MenuList>
              </Menu>
            </div>
            :
            ""
          ),
        };
      });
      return tableData;
    }
    return []
  },[statementRecords])


  if (loading) {
    return <SpinnerLoader />;
  }


  return (
    <Box display="flex" className="mx-0 expense_details account-statement">
      <Box className="expense_details_main account-statement-list">
        <Box display="flex" justifyContent="space-between" mt={5}>
         
          <Box className="ledger-year-select">
            <CustomDropdown
              years={financialYearOptions}
              selectedYear={selectedPeriod}
              setSelectedYear={setSelectedPeriod}
              handleApply={(date) => setDateRenge(date)}
              dateRenge={dateRenge}
            />
          </Box>

          <Text fontWeight="600" fontSize="14px" mt={3}>
            Statements Validate ( {dateRangeText} )
          </Text>
          <div></div>
        </Box>

        <Box className="acordian-box ">
          <Accordion defaultIndex={[0]} allowMultiple>
            <AccordionItem className="acordian-item" borderTop="none">
              <h2>
                <AccordionButton>
                  <Box flex="1" textAlign="left">
                    <Text fontWeight="600">Statements </Text>
                  </Box>

                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel className="acordian-panal  px-2 p-0 m-0">
                {statementData && statementData?.length > 0 ? (
                  <ExpenseTable
                    columnsData={statementColumns}
                    tableData={statementData}
                  />
                ) : (
                  <Text className="py-3" fontWeight="600" textAlign="center">
                    There are no history
                  </Text>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
        </Box>
      </Box>
    </Box>
  );
};

export default StatementValidate;
